if (!customElements.get('dunkel-size-guide')) {
  customElements.define('dunkel-size-guide', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.dialog = this.querySelector('dialog');
      this.trigger = this.querySelector('.dunkel-size-guide__trigger');
      if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
      this.trigger.addEventListener('click', (event) => {
        event.preventDefault();
        if (this.dialog.open) return;
        const image = this.dialog.querySelector('img');
        if (!image.src) image.src = image.dataset.src;
        this.previousOverflow = document.body.style.overflow;
        this.dialog.showModal();
        document.body.style.overflow = 'hidden';
      }, options);
      this.querySelector('.dunkel-size-guide__close').addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('click', (event) => {
        if (event.target !== this.dialog) return;
        const bounds = this.dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
      }, options);
      this.dialog.addEventListener('close', () => {
        document.body.style.overflow = this.previousOverflow ?? '';
        this.dialog.removeAttribute('data-zoomed');
        this.querySelector('.dunkel-size-guide__zoom').setAttribute('aria-pressed', 'false');
        const viewport = this.querySelector('.dunkel-size-guide__image-container');
        viewport.scrollTop = 0;
        viewport.scrollLeft = 0;
        this.trigger.focus({ preventScroll: true });
      }, options);
      this.querySelector('.dunkel-size-guide__zoom').addEventListener('click', (event) => {
        const zoomed = this.dialog.toggleAttribute('data-zoomed');
        event.currentTarget.setAttribute('aria-pressed', String(zoomed));
      }, options);
    }
    disconnectedCallback() {
      if (this.dialog?.open) {
        this.dialog.close();
        document.body.style.overflow = this.previousOverflow ?? '';
      }
      this.controller?.abort();
    }
  });
}
